import { BrowserRouter, Routes, Route } from 'react-router-dom'
import { AuthProvider } from './hooks/useAuth'
import { Layout } from './components/Layout'
import { Hero } from './components/sections/Hero'
import { Features } from './components/sections/Features'
import { Technology } from './components/sections/Technology'
import { Gallery } from './components/sections/Gallery'
import { Contact } from './components/sections/Contact'
import AdminLogin from './pages/admin/Login'
import AdminModels from './pages/admin/Models'
import NewModel from './pages/admin/NewModel'
import NewSolve from './pages/admin/NewSolve'
import SolveJobs from './pages/admin/SolveJobs'
import Workers from './pages/admin/Workers'
import EditModel from './pages/admin/EditModel'
import { ThumbnailGenerator } from './pages/admin/ThumbnailGenerator'
import AdminLeads from './pages/admin/Leads'
import LeadDetail from './pages/admin/LeadDetail'
import Dashboard from './pages/admin/Dashboard'
import ProtectedRoute from './components/admin/ProtectedRoute'
import { AdminLayout } from './components/admin/AdminLayout'
import { ShareViewer } from './pages/ShareViewer'
import { ARTest } from './pages/ARTest'
import TestXR from './pages/TestXR'

function HomePage() {
  return (
    <Layout>
      <Hero />
      <Features />
      <Technology />
      <Gallery />
      <Contact />
    </Layout>
  )
}

function App() {
  return (
    <BrowserRouter>
      <AuthProvider>
        <Routes>
          <Route path="/" element={<HomePage />} />
          <Route path="/share/:shareToken" element={<ShareViewer />} />
          <Route path="/ar-test" element={<ARTest />} />
          <Route path="/test-xr" element={<TestXR />} />
          <Route path="/admin/login" element={<AdminLogin />} />
          <Route
            path="/admin"
            element={
              <ProtectedRoute>
                <AdminLayout>
                  <Dashboard />
                </AdminLayout>
              </ProtectedRoute>
            }
          />
          <Route
            path="/admin/models"
            element={
              <ProtectedRoute>
                <AdminLayout>
                  <AdminModels />
                </AdminLayout>
              </ProtectedRoute>
            }
          />
          <Route
            path="/admin/solve"
            element={
              <ProtectedRoute>
                <AdminLayout>
                  <SolveJobs />
                </AdminLayout>
              </ProtectedRoute>
            }
          />
          <Route
            path="/admin/workers"
            element={
              <ProtectedRoute>
                <AdminLayout>
                  <Workers />
                </AdminLayout>
              </ProtectedRoute>
            }
          />
          <Route
            path="/admin/models/new"
            element={
              <ProtectedRoute>
                <AdminLayout>
                  <NewModel />
                </AdminLayout>
              </ProtectedRoute>
            }
          />
          <Route
            path="/admin/models/solve"
            element={
              <ProtectedRoute>
                <AdminLayout>
                  <NewSolve />
                </AdminLayout>
              </ProtectedRoute>
            }
          />
          <Route
            path="/admin/models/:id/edit"
            element={
              <ProtectedRoute>
                <AdminLayout>
                  <EditModel />
                </AdminLayout>
              </ProtectedRoute>
            }
          />
          <Route
            path="/admin/models/:id/thumbnail"
            element={
              <ProtectedRoute>
                <AdminLayout>
                  <ThumbnailGenerator />
                </AdminLayout>
              </ProtectedRoute>
            }
          />
          <Route
            path="/admin/leads"
            element={
              <ProtectedRoute>
                <AdminLayout>
                  <AdminLeads />
                </AdminLayout>
              </ProtectedRoute>
            }
          />
          <Route
            path="/admin/leads/:id"
            element={
              <ProtectedRoute>
                <AdminLayout>
                  <LeadDetail />
                </AdminLayout>
              </ProtectedRoute>
            }
          />
        </Routes>
      </AuthProvider>
    </BrowserRouter>
  )
}

export default App